import { render, staticRenderFns } from "./TlmButton.vue?vue&type=template&id=ebac52dc"
import script from "./TlmButton.vue?vue&type=script&lang=js"
export * from "./TlmButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports